import { SUBTOTAL } from '../../order-sale-form';
import { RhNumberField } from '../../../../../../../dum';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function SubtotalInput() {
    return (
        <RhNumberField
            name={SUBTOTAL}
            label={shortLabel(FIELD_LABELS.subtotal)}
            disabled
        />
    );
}
